import { put, takeLatest } from 'redux-saga/effects';

import { api, makeRequest } from 'shared/sdk';

const actionPrefix = 'CreateCompany/';

const SAVE_LOCATION_DATA = `${actionPrefix}SAVE_LOCATION_DATA`;

const FETCH_COUNTRIES = `${actionPrefix}FETCH_COUNTRIES`;
const SUCCESS_FETCH_COUNTRIES = `${actionPrefix}SUCCESS_FETCH_COUNTRIES`;
const FAIL_FETCH_COUNTRIES = `${actionPrefix}FAIL_FETCH_COUNTRIES`;

export const fetchCountries = () => ({
  type: FETCH_COUNTRIES
});

const successFetchCountries = payload => ({
  type: SUCCESS_FETCH_COUNTRIES,
  payload
});

const failFetchCountries = payload => ({
  type: FAIL_FETCH_COUNTRIES,
  payload
});

export const saveLocationData = payload => ({
  type: SAVE_LOCATION_DATA,
  payload
});

export const locationReducer = (newState, action) => {
  switch (action.type) {
    case SAVE_LOCATION_DATA:
      newState['companyLocationData'] = action.payload;
      break;
    case SUCCESS_FETCH_COUNTRIES:
      newState['countryChoices'] = action.payload;
      break;

    default:
      break;
  }
};

function* fetchCountriesWorker(action) {
  const response = yield makeRequest(api.countriesList, {
    requestData: {
      params: {
        limit: 500,
        offset: 0,
        ordering: 1
      }
    }
  });

  if (response.success) yield put(successFetchCountries(response.data.results));
  else yield put(failFetchCountries(response.errors));
}

export function* locationWatcher() {
  yield takeLatest(FETCH_COUNTRIES, fetchCountriesWorker);
}
